import { useCallback, useContext } from "react";
import { NavBarAndLandingPageContext } from "../../NavBarContextAndLandingPageContext";
import KpiMetricData from "../BiCatalogue/KpiMetric/KpiMetricData";
import BIWidgetData from "../BiCatalogue/Widgets/BIWidgetData";
import AllDatasetWidget from "../Datasets/AllDataSets/Individual/DatasetWidget/AllDatasetWidget";
import DomainOverview from "../Datasets/AllDataSets/Individual/DomainWidget/DomainOverview";
import OrgModelOverview from "../Datasets/AllDataSets/Individual/OrgModelWidgets/OrgModelOverview";
import SchemaOverview from "../Datasets/AllDataSets/Individual/SchemaWidget/SchemaOverview";

const DataCatalogueLanding = (props) => {
  const { roletoggle, widget, schema, maserskmodel, domaindata, bicatalogData, kpibicatalogData } = useContext(NavBarAndLandingPageContext);


  const memoizedOrgModel = useCallback(<OrgModelOverview maserskmodel={maserskmodel} />, [maserskmodel]);
  const memoizedDomain = useCallback(<DomainOverview domaindata={domaindata} />, [domaindata]);
  const memoizedBiWidget = useCallback(<BIWidgetData catalogData={bicatalogData} />, [bicatalogData]);
  const memoizedKpiMetric = useCallback(<KpiMetricData catalogData={kpibicatalogData} />, [kpibicatalogData]);
  const memoizedSchema = useCallback(<SchemaOverview schema={schema} />, [schema]);
  const memoizedDataset = useCallback(<AllDatasetWidget widget={widget} roletoggle={roletoggle} />, [widget, roletoggle]);

  return (
    <>
      <div className="test mb-0">

        {memoizedOrgModel}
        {memoizedDomain}
        {memoizedBiWidget}
        {memoizedKpiMetric}
        {/* Business disable as per Ashwini comment */}
        {/* <BusinessOverview /> */}
        {memoizedSchema}
        {memoizedDataset}
      </div>
    </>
  );
};

export default DataCatalogueLanding;
